export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-side-nav/index.js